import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '../loaders/Skeleton';
import EmdashText from '../common/EmdashText';
import HrbTranslate from '../../language/HrbTranslate';

const TimeOffsetDisplay = ({ loading, offsetSeconds }) => {
    const [value, setValue] = useState(-1);
    const [textKey, setTextKey] = useState(null);

    useEffect(() => {
        var offset = Number(offsetSeconds || 0)
        if (offset < 60 * 60) {
            var mins = Math.max(parseInt(offset / 60, 10), 1)
            setTextKey(mins === 1 ? "TimeOffset.Minute" : "TimeOffset.Minutes")
            setValue(mins)
        } else if (offset < 60 * 60 * 60) {
            var hours = parseInt(offset / 3600, 10)
            setTextKey(hours === 1 ? "TimeOffset.Hour" : "TimeOffset.Hours")
            setValue(hours)
        } else {
            var days = parseInt(offset / (3600 * 24), 10)
            setTextKey(days === 1 ? "TimeOffset.Day" : "TimeOffset.Days")
            setValue(days)
        }
    }, [offsetSeconds])

    return loading
        ? (<Skeleton />)
        : (value < 0)
            ? (<EmdashText />)
            : (<HrbTranslate text={textKey} params={{Value: value}} />)
}

TimeOffsetDisplay.propTypes = {
    offsetSeconds: PropTypes.number.isRequired,
    loading: PropTypes.bool
}

export default TimeOffsetDisplay;